import React from 'react';
import sidebarEPLogo from '../img/sidebar-logo-ep.svg';

function Sidebar(props) {

    return (
        <div>
            <div id="Sidebar" className={`sidebar ${props.showSidebar === true ? "sidebar-open" : "sidebar-close"}`}>
                <button className="sidebar-toggle" onClick={()=>props.sidebartoggle()}><i className="fas fa-bars"></i></button>
                <img className= "sidebar-logo" src={sidebarEPLogo} alt="brand-logo" />
                <h2 className= "sidebar-header">Student Portal</h2>
                <p className= "sidebar-name">{props.student.fullname}</p>
                <div className="sidebar-selection">
                    
                {props.menuitems ?    
                    
                props.menuitems.map(c =>  

                    <div className='sidebar-button-container' key={c.sortorder}>
                        <button className={`sidebar-item ${c.statusid === 4 ? 'active': ''}`} data-selection={c.btntxt} data-filter={c.statusid} onClick={(e, selection) => props.getSelection(e, selection)}><i className={"fas " + c.icon + " sidebar-icon"}/>
                            <span className="open-text">{c.btntxt}
                                <span className="record-count">{c.cnt}</span>
                            </span>
                            <span className="close-text">{c.btntxtshort}</span>
                        </button>
                    </div>

                 
                )  : null }
                     
                    <div className='sidebar-button-container'>
                        <a className="sidebar-item" href="https://stsupport.exampro.co.uk/kb/" target="_blank" rel="noreferrer"><i className="fas fa-question" />Help</a>
                    </div>
                    <div className='sidebar-button-container'>
                        <a className="sidebar-item" href="/logout.php"><i className="fa fa-power-off" />Logout</a>
                    </div>
      
             </div>
            </div>
        </div>
    );
}

export default Sidebar;